<template>

</template>

<script>
export default {
name: "MapCarouselControlConfiguration"
}
</script>

<style scoped lang="scss">

</style>
